import { Modal } from "antd";
import i18next from "i18next";

export const featureIsNotAvailable = (isDemo) => {
  Modal.error({
    title: i18next.t('Feature not available'),
    content: isDemo ? 'This feature is not available in demo mode.' : 'This feature is not available to you.',
    okText: 'Ok',
    onOk: () => { },
    maskClosable: true,
  });
}